import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';

const CuentaBancariaCard = ({ cuenta, onEditar, onEliminar }) => {
    const navigate = useNavigate();

    return (
        <Card className="h-100 shadow-sm border-0 bg-white card-hover-effect" style={{ borderRadius: '12px', transition: 'transform 0.2s, box-shadow 0.2s' }}
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.08)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 0.125rem 0.25rem rgba(0,0,0,0.075)'; }}
        >
            <Card.Body className="p-4 d-flex flex-column">
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <div className="d-flex align-items-center" style={{ minWidth: 0 }}>
                        <div className="bg-primary bg-opacity-10 text-primary rounded d-flex justify-content-center align-items-center me-2 flex-shrink-0" style={{ width: '32px', height: '32px' }}>
                            <FontAwesomeIcon icon="building-columns" style={{ fontSize: '0.9rem' }} />
                        </div>
                        <div className="text-truncate">
                            <span className="mb-0 fw-bold text-dark d-block text-truncate" style={{ fontSize: '0.9rem' }}>{cuenta.vNombreBanco}</span>
                            <small className="text-muted fw-medium text-truncate d-block" style={{ fontSize: '0.75rem' }}>{cuenta.vAlias || 'Cuenta Principal'}</small>
                        </div>
                    </div>
                </div>
                
                <div className="mt-1 mb-2 bg-light rounded p-2">
                    <div className="d-flex justify-content-between mb-2 align-items-center border-bottom pb-2 flex-wrap">
                        <small className="text-muted fw-bold me-2" style={{ fontSize: '0.65rem' }}>SALDO DISPONIBLE</small>
                        <span className="fw-bold text-dark" style={{ fontSize: '1rem' }}>
                            ${(Math.random() * 200000 + 10000).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </span>
                    </div>
                    <div className="d-flex justify-content-between mb-1 flex-wrap">
                        <small className="text-muted fw-bold me-2" style={{ fontSize: '0.65rem' }}>NO. CUENTA</small>
                        <span className="fw-medium text-dark text-break text-end" style={{ fontSize: '0.8rem', letterSpacing: '0.5px' }}>{cuenta.vNumCta}</span>
                    </div>
                    <div className="d-flex justify-content-between flex-wrap">
                        <small className="text-muted fw-bold me-2" style={{ fontSize: '0.65rem' }}>CLABE</small>
                        <span className="fw-medium text-dark text-break text-end" style={{ fontSize: '0.8rem', letterSpacing: '0.5px' }}>{cuenta.vClabe || '-'}</span>
                    </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-auto">
                    <Badge bg="light" text="dark" className="border text-uppercase px-2 py-1" style={{ fontSize: '0.7rem' }}>
                        {cuenta.vMoneda || 'MXN'}
                    </Badge>
                    
                    <div className="d-flex gap-2">
                        <Button variant="light" size="sm" className="text-primary rounded-circle" style={{ width: '32px', height: '32px', padding: 0 }} onClick={() => navigate(`/contabilidad/bancos/cuenta-bancaria/${cuenta.idCatCuentaBancaria}`)} title="Ver detalle">
                            <FontAwesomeIcon icon="eye" />
                        </Button>
                        <Button variant="light" size="sm" className="text-secondary rounded-circle" style={{ width: '32px', height: '32px', padding: 0 }} onClick={() => onEditar(cuenta)} title="Editar cuenta">
                            <FontAwesomeIcon icon="edit" />
                        </Button>
                        <Button variant="light" size="sm" className="text-danger rounded-circle" style={{ width: '32px', height: '32px', padding: 0 }} onClick={() => onEliminar(cuenta)} title="Eliminar cuenta">
                            <FontAwesomeIcon icon="trash" />
                        </Button>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

CuentaBancariaCard.propTypes = {
    cuenta: PropTypes.shape({
        idCatCuentaBancaria: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        vNombreBanco: PropTypes.string,
        vAlias: PropTypes.string,
        vNumCta: PropTypes.string,
        vClabe: PropTypes.string,
        vMoneda: PropTypes.string
    }).isRequired,
    onEditar: PropTypes.func.isRequired,
    onEliminar: PropTypes.func.isRequired
};

export default CuentaBancariaCard;
